import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Campaign {
  id: string;
  name: string;
  type: string;
  status: string;
  content: { headline?: string; body?: string; cta_text?: string; cta_url?: string };
  start_date: string | null;
  end_date: string | null;
}

/** Fetch active banner campaigns */
export function useActiveBanners() {
  return useQuery({
    queryKey: ["active-banners"],
    queryFn: async () => {
      const now = new Date().toISOString();
      const { data, error } = await supabase
        .from("marketing_campaigns")
        .select("*")
        .eq("status", "active")
        .eq("type", "banner");
      if (error) throw error;
      // Filter by date range client-side
      return (data || []).filter((c: any) => {
        if (c.start_date && c.start_date > now) return false;
        if (c.end_date && c.end_date < now) return false;
        return true;
      }) as Campaign[];
    },
    staleTime: 1000 * 60 * 2,
  });
}

/** Fetch active announcement (notification type) */
export function useActiveAnnouncement() {
  return useQuery({
    queryKey: ["active-announcement"],
    queryFn: async () => {
      const now = new Date().toISOString();
      const { data, error } = await supabase
        .from("marketing_campaigns")
        .select("*")
        .eq("status", "active")
        .eq("type", "notification")
        .limit(1);
      if (error) throw error;
      const filtered = (data || []).filter((c: any) => {
        if (c.start_date && c.start_date > now) return false;
        if (c.end_date && c.end_date < now) return false;
        return true;
      });
      return filtered[0] as Campaign | undefined;
    },
    staleTime: 1000 * 60 * 2,
  });
}
